/**
 * This function is called to make a JSON for the worker with information to
 * render.
 *
 * @param numFrames      Number of frames since last update
 * @param mX             Mouse X position
 * @param mY             Mouse Y position
 * @param isMousePressed Is the mouse pressed
 * @param keys           List of keys pressed
 *
 * @returns The JSON string representing the data with the given parameters
 */
export function serializeToJson(
	numFrames: number,
	mX: number,
	mY: number,
	isMousePressed: boolean,
	keys: {key: string; code: string}[]
) {
	const fakeElapsed = performance.now();
	const now = new Date();
	const options = {
		weekday: "long",
		year: "numeric",
		month: "long",
		day: "numeric",
	} as const;
	const formattedDate = now.toLocaleDateString("en-US", options);
	const [weekday, month, day, year] = formattedDate.split(" ");

	const data = {
		numberOfUpdates: numFrames,
		playerEvents: [
			{
				playerId: 1,
				mouseX: mX,
				mouseY: mY,
				leftMouseClick: isMousePressed,
				// TODO: Get right mouse click
				rightMouseClick: false,

				keyboardEvents: Array.from(keys),
			},
		],
		// TODO: The time stuff doesn't work on the Java End yet
		elapsedTime: fakeElapsed,
		month: month,
		day: parseInt(day!, 10),
		dayName: weekday,
		year: parseInt(year!, 10),
		hour: now.getHours(),
		minute: now.getMinutes(),
		second: now.getSeconds(),
	};

	const jsonString = JSON.stringify(data, null, 2);
	return jsonString;
}
